import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { PDFDocument } from 'pdf-lib';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { useParams } from 'react-router-dom';
import { fullScreenPlugin } from '@react-pdf-viewer/full-screen';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getFilePlugin } from '@react-pdf-viewer/get-file';
const pdfjsDist = require('pdfjs-dist/package.json');
const BeforeSignedFile = forwardRef(function BeforeSignedFile(
    {
        setIsSigned,
        setLoading,
        isSigned,
        success,
        setSuccess,
        setLinkExpiered,
    },
    ref
) {
    const params = useParams();
    const [mergedPdfUrl, setMergedPdfUrl] = useState(null);
    const zoomPluginInstance = zoomPlugin();
    const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;
    const fullScreenPluginInstance = fullScreenPlugin();
    const { EnterFullScreenButton } = fullScreenPluginInstance;
    const getFilePluginInstance = getFilePlugin({
        fileNameGenerator: (file) => {
            // `file.name` is the URL of opened file
            const fileName = `merchant-processing-agreement-${file.name.substring(file.name.lastIndexOf('/') + 1)}`;
            return fileName;
        }
    });
    const { DownloadButton } = getFilePluginInstance;

    const downloadBtnWrapperRef = useRef(null);

    useImperativeHandle(ref, () => ({
        download() {
            downloadBtnWrapperRef.current
                ?.querySelector('button')
                ?.click();
        },
    }));


    const getPdfBase64 = async (url) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();

            return await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64WithPrefix = reader.result;
                    const base64Only = base64WithPrefix.split(',')[1]; // Remove prefix
                    resolve(base64Only);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob); // Converts to base64 with prefix
            });
        } catch (error) {
            console.error("Error converting PDF to base64:", error);
            return null;
        }
    };


    const getBase64Strings = async () => {
        try {
            setLoading(true);
            const data = {
                mfa_id: params?.mfa_key,
                fractalpayPublicKey: params?.public_key,
            };
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/getpdf`, data);
            if (response?.data?.result === false && response?.data?.message === 'Link is expired!') {
                setSuccess(true);
                setLinkExpiered(true);
            }
            // if (response?.status) {
            //     setIsSigned((response?.data?.data?.encoded_sign_pdf && response?.data?.data?.encoded_guide_signed_program_pdf) ? true : false);
            //     let str1 = response?.data?.data?.encoded_sign_pdf ? response?.data?.data?.encoded_sign_pdf : response?.data?.data?.encoded_mfa_pdf
            //     let str2 = response?.data?.data?.encoded_guide_signed_program_pdf ? response?.data?.data?.encoded_guide_signed_program_pdf : response?.data?.data?.encoded_guided_pdf
            //     let skyfi_document_pdfUrl = response?.data?.data?.skyfi_document; // Commented out mike
            //     let str3 = await getPdfBase64(skyfi_document_pdfUrl).then((base64String) => {
            //        return base64String;
            //     });
            //     mergePdfs(str1, str2 ,str3 ); // Commented out mike str3
            // }

            if (response?.status) {

                const rows = response?.data?.data || [];
                if (!Array.isArray(rows) || rows.length === 0) return;

                // Determine if all rows are fully signed
                const hasAllSignatures = rows.every(
                    row => row.mfa_sign_pdf && row.guide_signed_program_pdf
                );
                setIsSigned(hasAllSignatures);


                // Temp arrays to hold PDFs by pricing type
                let flatList = [];
                let icList = [];
                let str3 = ''

                for (const row of rows) {

                    let str1 = row.mfa_sign_pdf || row.mfa_pdf;
                    let str2 = row.guide_signed_program_pdf || row.guide_program_pdf;

                    str1 = await getPdfBase64(str1);
                    str2 = await getPdfBase64(str2);

                    str3 = row.skyfi_document
                        ? await getPdfBase64(row.skyfi_document)
                        : null;

                    const pdfs = [str1, str2].filter(Boolean);

                    if (row.pricing_type === "flat") {
                        flatList.push(...pdfs);
                    } else if (row.pricing_type === "ic") {
                        icList.push(...pdfs);
                    }
                }

                // Store in state

                if (flatList || icList) {
                    let docs = await mergePdfs(...flatList, ...icList, str3);
                    // console.log(docs, "memememem", ...flatList, ...icList, str3);
                    setMergedPdfUrl(docs);
                }

                // if (flatList.length > 0) {
                //     let flatdocs = await mergePdfs(...flatList)
                //     setFlatDocuments(flatdocs);
                // }

                // if (icList.length > 0) {
                //     let icdocs = await mergePdfs(...icList)
                //     setIcDocuments(icdocs);
                // }

            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
            toast.error(error?.response?.data?.message);
        }
    }

    // const mergePdfs = async (string1, string2, string3) => { // Commented out mike string3
    //     try {
    //         // Assume you get these base64 strings from some API or source
    //         const base64Pdf1 = string1;
    //         const base64Pdf2 = string2;
    //         const base64Pdf3 = string3; // Commented out mike

    //         // Decode base64 to ArrayBuffer
    //         const decodeBase64 = (base64) => {
    //             const binaryString = window.atob(base64);
    //             const len = binaryString.length;
    //             const bytes = new Uint8Array(len);
    //             for (let i = 0; i < len; i++) {
    //                 bytes[i] = binaryString.charCodeAt(i);
    //             }
    //             return bytes.buffer;
    //         };

    //         const pdf1 = decodeBase64(base64Pdf1);
    //         const pdf2 = decodeBase64(base64Pdf2);
    //         const pdf3 = decodeBase64(base64Pdf3); // Commented out mike

    //         // Load both PDFs
    //         const pdfDoc1 = await PDFDocument.load(pdf1, { ignoreEncryption: true });
    //         const pdfDoc2 = await PDFDocument.load(pdf2, { ignoreEncryption: true });
    //         const pdfDoc3 = await PDFDocument.load(pdf3, { ignoreEncryption: true }); // Commented out mike
    //         // Create a new PDFDocument
    //         const mergedPdfDoc = await PDFDocument.create();

    //         // Copy all pages from pdfDoc1 and pdfDoc2
    //         const pages1 = await mergedPdfDoc.copyPages(pdfDoc1, pdfDoc1.getPageIndices());
    //         pages1.forEach((page) => mergedPdfDoc.addPage(page));

    //         const pages2 = await mergedPdfDoc.copyPages(pdfDoc2, pdfDoc2.getPageIndices());
    //         pages2.forEach((page) => mergedPdfDoc.addPage(page));

    //         const pages3 = await mergedPdfDoc.copyPages(pdfDoc3, pdfDoc3.getPageIndices()); // Commented out mike
    //         pages3.forEach((page) => mergedPdfDoc.addPage(page)); // Commented out mike

    //         // Serialize the merged PDF document to bytes
    //         const mergedPdfBytes = await mergedPdfDoc.save();

    //         // Convert the merged PDF bytes to a Blob and create an object URL
    //         const mergedPdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
    //         const mergedPdfUrl = URL.createObjectURL(mergedPdfBlob);

    //         // Set merged PDF URL to state
    //         // setMergedPdfUrl(mergedPdfUrl);
    //         return mergedPdfUrl
    //     } catch (error) {
    //         console.error('Error merging PDFs:', error.message);
    //     }
    // };

    const mergePdfs = async (...strings) => {
        try {
            // Utility to decode base64
            const decodeBase64 = (base64) => {
                const binaryString = window.atob(base64);
                const len = binaryString.length;
                const bytes = new Uint8Array(len);
                for (let i = 0; i < len; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                return bytes.buffer;
            };

            // Create new merged PDF
            const mergedPdfDoc = await PDFDocument.create();

            // Loop through all provided base64 strings (max 6)
            for (const base64Pdf of strings) {
                if (!base64Pdf) continue; // Skip empty values

                const pdfArrayBuffer = decodeBase64(base64Pdf);

                // Load PDF
                const pdfDoc = await PDFDocument.load(pdfArrayBuffer, { ignoreEncryption: true });

                // Copy and append pages
                const pages = await mergedPdfDoc.copyPages(pdfDoc, pdfDoc.getPageIndices());
                pages.forEach((page) => mergedPdfDoc.addPage(page));
            }

            // Save merged PDF
            const mergedPdfBytes = await mergedPdfDoc.save();
            const mergedPdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
            const mergedPdfUrl = URL.createObjectURL(mergedPdfBlob);

            return mergedPdfUrl;

        } catch (error) {
            console.error("Error merging PDFs:", error.message);
        }
    };


    useEffect(() => {
        getBase64Strings();

    }, [success]);


    return (
        <>

            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsDist.version}/build/pdf.worker.min.js`}>
                <div className='file-viewer'  >
                    {/* Zoom and Full Screen Controls */}
                    <div className='controls'>
                        <ZoomOut>
                            {(props) => (
                                <button className='zoom' onClick={props.onClick}>
                                    -
                                </button>
                            )}
                        </ZoomOut>
                        <CurrentScale>
                            {(props) => (
                                <span style={{ margin: '0 8px', color: '#121212' }}>
                                    {`${Math.round(props.scale * 100)}%`}
                                </span>
                            )}
                        </CurrentScale>
                        <ZoomIn>
                            {(props) => (
                                <button className='zoom' onClick={props.onClick}>
                                    +
                                </button>
                            )}
                        </ZoomIn>
                        <span className='full-screen'>
                            <EnterFullScreenButton />
                        </span>
                        {isSigned &&
                            <span className='full-screen' ref={downloadBtnWrapperRef} style={{ display: 'none' }}>
                                <DownloadButton />
                            </span>
                        }
                    </div>

                    {/* PDF Viewer */}
                    {mergedPdfUrl && (
                        <Viewer fileUrl={mergedPdfUrl} plugins={[zoomPluginInstance, fullScreenPluginInstance, getFilePluginInstance]} />
                    )}
                </div>
            </Worker>
        </>
    );
});

export default BeforeSignedFile;
